const NODE_ENV = process.env.NODE_ENV;
let baseUrl = `/api`;
if (NODE_ENV === "development") {
  baseUrl = "http://pc-api-dev.996box.com";
}
if (NODE_ENV === "production") {
  baseUrl = "//pc-api.996box.com";
}

export default {
  user: {
    // 登录
    login: `${baseUrl}/user/login`,
    // 登出
    logout: `${baseUrl}/user/logout`,
    // 获取用户信息
    getInfo: `${baseUrl}/user/getUserInfo`,
    // 获取菜单
    getMenu: `${baseUrl}/user/getMenu`,
    // 获取用户信息
    getUserInfo: `${baseUrl}/getUserInfo`,

    // 校验用户
    CheckUser: `${baseUrl}/v1/RoleInfo/CheckUser`,
    // 获取游戏
    UserGames: `${baseUrl}/v1/RoleInfo/UserGames`,
    // 获取区服
    ServerList: `${baseUrl}/v1/RoleInfo/ServerList`,
  },
};
